<ngx-slick-carousel class="destination-single-slider carousel" #slickModal="slick-carousel" [config]="slideConfig">
    <div ngxSlickItem *ngFor="let slide of slides" class="slide">
        <div class="slides">
            <div class="slide-image" [ngStyle]="{background: 'url('+ slide + ')' + 'no-repeat center / cover,#cccccc'}">
            </div>
        </div>
    </div>
</ngx-slick-carousel>